import { NextSeo } from 'next-seo';

//screens
import { TrackingAndStatusUpdates } from '@/screens/Agents/TrackingAndStatusUpdates';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function TrackingAndStatusUpdatesPage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/tracking-and-status-updates/"
        title="Tracking & Status Updates Agent | Loadsmart AI"
        description="Pulls carrier status on a schedule, chases the carriers that go quiet, escalates the ones that stay quiet, and pushes clean updates to your team and your customers."
        openGraph={{
          url: 'https://loadsmart.com/ai/tracking-and-status-updates/',
        }}
      />
      <JsonLd data={Organization} />
      <TrackingAndStatusUpdates />
    </>
  );
}
